import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader, DownloadButton } from 'components';
import services from 'services';
import { saveAs } from 'file-saver';
import { useStyles } from './style';

type Extension = 'pdf' | 'doc' | 'xls';

interface Props {
  disabled?: boolean;
  extension?: Extension;
  name?: string;
  url: string | null;
}

function getTitleByExtension(extension: Extension) {
  switch (extension) {
    case 'doc':
      return 'word';
    case 'xls':
      return 'excel';
    default:
      return 'pdf';
  }
}

const Download: React.FC<Props> = ({
  disabled,
  extension = 'pdf',
  name = 'test',
  url,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const download = async () => {
    if (url) {
      setLoading(true);
      try {
        const { data } = await services({
          url,
          method: 'GET',
          responseType: 'blob',
          headers: {
            Accept: '*/*',
          },
        });

        saveAs(data, `${name}.${extension}`);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
  };

  const isDisabledBtn = !url || disabled;

  return (
    <>
      {loading ? (
        <Loader className={classes.loader} size={20} />
      ) : (
        <DownloadButton onClick={download} disabled={isDisabledBtn}>
          {`${t(
            '#portal.report.cooperative.buttons.download'
          )} ${getTitleByExtension(extension)}`}
        </DownloadButton>
      )}
    </>
  );
};

export default Download;
